import { render, staticRenderFns } from "./UnauthorisedParkingList.vue?vue&type=template&id=cab9a60c"
import script from "./UnauthorisedParkingList.vue?vue&type=script&lang=js"
export * from "./UnauthorisedParkingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports